import { ReactElement } from "react";

export default function UseQueryError(): ReactElement {
  return (
    <div>
      Nej! Något gick fel... Försök ladda om sidan eller logga in och ut.
    </div>
  );
}
